export default class NavCarousel {
  constructor(options) {
    const _defaults = {};
    this.defaults = Object.assign({}, _defaults, options);
  }

  init() {
    $('.js-faq-trigger').on('click', function () {

      let allContent = $('.js-faq-content'),
        nextContent = $(this).next('.js-faq-content');

      $('.js-faq-trigger').not($(this)).removeClass('is-active');
      $(this).toggleClass('is-active');

      allContent.not(nextContent).slideUp();
      nextContent.slideToggle();
    });
  }

}


// WEBPACK FOOTER //
// ./static/js/components/Faq.js